import { GroupPlayer } from '@/modules/league/new-components/types';

// One of these columns shows on group card for each player row in group when match is started
export const clubRatingColumns: { key: string; label: string; dataKey: keyof GroupPlayer }[] = [
  { key: 'w', label: 'Wins', dataKey: 'TeamWins' },
  { key: 'h2h', label: 'Head to Head Wins', dataKey: 'TeamHeadToHeadWins' },
  { key: 'e', label: 'Points Earned', dataKey: 'TeamPointsEarned' },
  { key: 'a', label: 'Points Against', dataKey: 'TeamPointsAgainst' },
  { key: 'dif', label: 'Difference Earned Against', dataKey: 'TeamDifference_EarnedAgainst' },
  {
    key: 'h2h dif',
    label: 'Head to Head Point Difference Within Head To Head',
    dataKey: 'TeamHeadToHead_PointDifferenceWithinHeadToHead',
  },
  { key: 'l', label: 'Losses', dataKey: 'TeamLosses' },
];

export const factorStatsColumns: { key: string; label: string; dataKey: keyof GroupPlayer }[] = [
  {
    key: 'E/P diff%',
    label: 'Total Points - Earned Possible Percentage',
    dataKey: 'TeamPointDifferencePercentage',
  },
  { key: 'e', label: 'Points Earned', dataKey: 'TeamPointsEarned' },
  { key: 'a', label: 'Points Against', dataKey: 'TeamPointsAgainst' },
  { key: 'P', label: 'Total Points Possible', dataKey: 'TeamPointsPossible' },
  { key: 'w', label: 'Wins', dataKey: 'TeamWins' },
  { key: 'l', label: 'Losses', dataKey: 'TeamLosses' },
];

export const upDownColumns: { key: string; label: string; dataKey: keyof GroupPlayer }[] = [
  { key: 'st', label: 'Standings', dataKey: 'TeamNewSeedNumber' },
  { key: 'w', label: 'Wins', dataKey: 'TeamWins' },
  { key: 'h2h', label: 'Head to Head Wins', dataKey: 'TeamHeadToHeadWins' },
  { key: 'dif', label: 'Difference Earned Against', dataKey: 'TeamDifference_EarnedAgainst' },
  {
    key: 'h2h dif',
    label: 'Head to Head Point Difference Within Head To Head',
    dataKey: 'TeamHeadToHead_PointDifferenceWithinHeadToHead',
  },
  { key: 'l', label: 'Losses', dataKey: 'TeamLosses' },
  { key: 'e', label: 'Points Earned', dataKey: 'TeamPointsEarned' },
  { key: 'a', label: 'Points Against', dataKey: 'TeamPointsAgainst' },
];

// For displaying date in HeaderContent
export const dateOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
  timeZone: 'America/Los_Angeles', // set the timezone to PST
};

// Links for navigation on Game Day pages
export const gameDayLinks = [
  { type: 'rsvp', label: 'RSVPS' },
  { type: 'groups', label: 'Groups' },
  { type: 'matches', label: 'Matches' },
];

// Sort options on RSVP cards
export const SORT_OPTIONS = [
  { label: 'Name A-Z', value: 'asc' },
  { label: 'Name Z-A', value: 'desc' },
  { label: 'Rank', value: 'ranks' },
];

// Csv file for playing list
export const csvHeaders = [
  { label: 'Last Name (1)', key: 'LastName_1' },
  { label: 'First Name (1)', key: 'FirstName_1' },
  { label: 'Last Name (2)', key: 'LastName_2' },
  { label: 'First Name (2)', key: 'FirstName_2' },
];

// Links for all game days
export const allGameDayLinks = [
  { type: 'upcoming', label: 'Upcoming' },
  { type: 'past', label: 'Past' },
];

// Links for all sessions
export const allSessionsLinks = [
  { type: 'current', label: 'Current' },
  { type: 'past', label: 'Past' },
];

// Options for Select on RSVP page - UpDown league Rounds
export const upDownOptions = [
  { value: '1', label: 'Round 1' },
  { value: '2', label: 'Round 2' },
];

// Options for Print score sheets
export const sizeOfSheet = [
  { value: 'half', label: 'Half Sheets' },
  { value: 'full', label: 'Full Sheets' },
];

export const NEXT_PUBLIC_PL_KEY = process.env.NEXT_PUBLIC_PL_KEY;

export const MOVED_FROM_WAIT_EMAIL_TEMPLATE_ID = 'd-f67168b414e74c8984e00d621c0d0ce3';

export const CONTENT_TYPE_FOR_NOTIFICATION = 'TRANSACTIONAL_CONTENT';
